import * as Types from '../constants/actionTypes';
const defaultList = {
    docTypeList: [],
    docTypeError: ''
}

export default (state = defaultList, action) => {
    switch (action.type) {
        case Types.DOCUMENT_TYPE_LIST:
            return {
                ...state,
                docTypeList: action.payload
            }
        case Types.DOCUMENT_TYPES_COUNT_SUCCESS:
            return {
                    ...state,
                    docTypeListCount: action.payload
            }

        case Types.ON_ADD_DOCUMENT_TYPE:
            state.docTypeList.push(action.payload)
            return {
                ...state
            }
        case Types.ON_NEW_REQUEST_DOCUMENT:
            return {
                ...state,
                newRequestDocument:action.payload
            }
            
        case Types.ON_DELETE_DOCUMENT_TYPE:
            state.docTypeList.splice(action.deleteIndex, 1)
            return {
                ...state
            }

        /* currencyes list */
        
        case Types.DOCUMENT_TYPE_ERROR: {
            return {
                ...state,
                docTypeError: action.docTypeError
            }
        }
        case Types.ON_UPDATED_DOCUMENT_TYPE:
            state.docTypeList[action.updateIndex] = action.payload
            return {
                ...state
            }
        case Types.CLIENT_DOCUMENT_TYPE_LIST:
            return {
                ...state,
                clientDocTypeList: action.payload
            }
        default:
            return state
    }
}
